/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBPROFESSION = 'GETCLUBPROFESSION'
export const GETTOTALTYPE = 'GETTOTALTYPE'




// WEBPACK FOOTER //
// ./src/containers/ClubProfession/constants.js